import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'

import helpers from 'helpers'
import constants from 'constants/index'

const PartnerAuditForm = ({ control, errors, companySupplier, setValue }) => {
  const { PROGRESS_STATUSES_LABEL } = constants.companySuppliers

  const audits = companySupplier?.companySupplierAudits || []

  const auditOptions = audits.map((audit) => {
    const startDate =
      helpers.formatters.date(audit.dateToSendEmails) ||
      '[Data de inicio não informada]'
    const endDate =
      helpers.formatters.date(audit.endDate) || '[Prazo final não informado]'
    const progressLabel = PROGRESS_STATUSES_LABEL[audit.progressStatus]

    return {
      id: audit.id,
      name: `#${audit.id} • ${startDate} - ${endDate}${
        progressLabel ? ` • ${progressLabel}` : ''
      }`,
    }
  })

  useEffect(() => {
    setValue('auditId', null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySupplier?.id])

  return (
    <Controller
      as={
        <Autocomplete
          options={auditOptions}
          getOptionLabel={(option) => option?.name || ''}
          getOptionSelected={(option, value) => option?.id === value?.id}
          noOptionsText="Nenhuma auditoria encontrada"
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors?.auditId}
              helperText={errors?.auditId?.message}
              fullWidth
              variant="outlined"
              label="Auditoria"
            />
          )}
        />
      }
      name="auditId"
      control={control}
      defaultValue={null}
      onChange={([, data]) => data}
      mode="onChange"
    />
  )
}

export default PartnerAuditForm
